import { render, staticRenderFns } from "./WhatsappStatusBadge.vue?vue&type=template&id=03b6ad46&scoped=true"
import script from "./WhatsappStatusBadge.vue?vue&type=script&lang=js"
export * from "./WhatsappStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./WhatsappStatusBadge.vue?vue&type=style&index=0&id=03b6ad46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b6ad46",
  null
  
)

export default component.exports